import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Contact, FilterCategory, TargetPayload } from './contacts.model';
import { environment } from '../../../environments/environment';
@Injectable({ providedIn: 'root' })
export class ContactsService {
  private readonly http = inject(HttpClient);

  // --- Contacts CRUD ---

  getContacts(phoneServiceId: number): Observable<Contact[]> {
    return this.http.get<Contact[]>(`${environment.phoneServiceUrl}/contacts`, {
      params: { phoneServiceId: phoneServiceId.toString() },
    });
  }

  createContact(contact: Partial<Contact>, employeeId: string): Observable<Contact> {
    return this.http.post<Contact>(`${environment.phoneServiceUrl}/contacts`, contact, {
      params: { employeeId },
    });
  }

  updateContact(contact: Partial<Contact>): Observable<Contact> {
    return this.http.put<Contact>(`${environment.phoneServiceUrl}/contacts/${contact.id}`, contact);
  }

  deleteContact(contactId: number, employeeId: string): Observable<void> {
    return this.http.delete<void>(`${environment.phoneServiceUrl}/contacts/${contactId}`, {
      params: { employeeId },
    });
  }

  // --- Targets CRUD ---

  createTarget(target: TargetPayload): Observable<any> {
    return this.http.post(`${environment.phoneServiceUrl}/targets`, target);
  }

  updateTarget(target: TargetPayload): Observable<any> {
    return this.http.put(`${environment.phoneServiceUrl}/targets/${target.id}`, target);
  }

  deleteTarget(targetId: number, targetType: string): Observable<void> {
    return this.http.delete<void>(`${environment.phoneServiceUrl}/targets/${targetId}`, {
      params: { targetType },
    });
  }

  // --- Target reordering ---

  switchUp(contactId: number, sortNumber: number): Observable<any> {
    return this.http.put(`${environment.phoneServiceUrl}/targets/switchUp/${contactId}/${sortNumber}`, null);
  }

  switchDown(contactId: number, sortNumber: number): Observable<any> {
    return this.http.put(`${environment.phoneServiceUrl}/targets/switchDown/${contactId}/${sortNumber}`, null);
  }

  // --- Filter categories ---

  getFilterCategories(phoneServiceId: number): Observable<FilterCategory[]> {
    return this.http.get<FilterCategory[]>(
      `${environment.phoneServiceUrl}/phoneservices/${phoneServiceId}/filterCategories`,
    );
  }

  createFilterCategory(phoneServiceId: number, name: string): Observable<FilterCategory> {
    return this.http.post<FilterCategory>(
      `${environment.phoneServiceUrl}/phoneservices/${phoneServiceId}/filterCategories`,
      { name },
    );
  }

  // --- Filter values ---

  addFilterValue(contactId: number, filterValue: { name: string; categoryId: number }): Observable<any> {
    return this.http.post(`${environment.phoneServiceUrl}/filterValues/contacts/${contactId}`, filterValue);
  }

  removeFilterValue(filterId: number, contactId: number): Observable<void> {
    return this.http.delete<void>(`${environment.phoneServiceUrl}/filterValues/${filterId}/contacts/${contactId}`);
  }
}
